import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentPlus = () => {
  return (
    <g>
      <path d="m5.94.005 8.012.012C14.53.018 15 .487 15 1.067V14.95c0 .58-.47 1.05-1.05 1.05H2.05C1.47 16 1 15.53 1 14.95V4.94L5.94.004zM7 1.505V4.95c0 .541-.41.987-.936 1.044L5.95 6H2.5v8.5h11V1.514L7 1.505zM8 6.5a.75.75 0 0 1 .75.75v2h2a.75.75 0 1 1 0 1.5h-2v2a.75.75 0 1 1-1.5 0v-2h-2a.75.75 0 1 1 0-1.5h2v-2A.75.75 0 0 1 8 6.5zM5.5 2.563 3.561 4.5H5.5V2.562z" />
    </g>
  );
};

export default withIcon(IconDocumentPlus);
